'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoChatboxes = function IoChatboxes(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.7 28.6l2.1 1.4c-0.4 1.6-2.3 2.5-4.1 2.5h-7c-0.7 0-0.9 0.2-1.1 0.2l-4.1 3.6v-3.8h-1.2c-2.1 0-3.8-1.2-3.8-3.2v-10.1c0-1.9 1.6-3.5 3.6-3.5h0.1v7.9c0 2.6 2.3 4.6 5 4.6h9.2c0.8 0 1.1 0.2 1.3 0.4z m8.4-24.8c2.7 0 4.9 2.1 4.9 4.6v13.2c0 2.5-2.2 4.7-4.9 4.7h-1.3v5l-5.9-4.7c-0.2-0.2-0.6-0.3-1.3-0.3h-7.9c-2.8 0-4.9-2.2-4.9-4.7v-13.2c0-2.5 1.6-4.7 4.3-4.7h17z' })
        )
    );
};

exports.default = IoChatboxes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/chatboxes.js
// module id = 1979
// module chunks = 0